import { useQuery } from '@tanstack/react-query';
import { getHardwareOptions } from '../api';

const DAY_MS = 24 * 60 * 60 * 1000;

export const hardwareKeys = {
  all: ['hardwares'] as const,
  type: (type: string) => [...hardwareKeys.all, type] as const,
};

/**
 * Fetch hardware options (base, module, connectivity).
 * Long cache — hardware lists rarely change.
 */
export function useHardwareOptions(type: 'base' | 'module' | 'connectivity') {
  return useQuery({
    queryKey: hardwareKeys.type(type),
    queryFn: () => getHardwareOptions(type),
    staleTime: DAY_MS,
  });
}
